<template>
  <b-container fluid>
    <iq-card>
      <template v-slot:headerTitle>
        <h4 class="card-title title-typography-color">
          <i class="fas fa-search"></i>
          {{
            $t("public.views.Pages.Professional.Admin.Invoices.search.title")
          }}
        </h4>
      </template>
      <template v-slot:headerAction>
        <b-button class="mr-2" style="right" variant="primary" @click="goToInvoice">Volver
        </b-button>
      </template>
      <template v-slot:body>
        <b-row>
          <b-col lg="3" md="3" sm="6" xl="3">
            <b-form-group label-for="dateAtStart">
              <template slot="label">{{
                $t(
                  "public.views.Pages.Professional.Admin.Invoices.dateAtStart"
                )
              }}:
              </template>
              <date-picker v-model="filter.startTo" :format="myFormat" :formatter="momentFormat" class="w-100" type="date"
                @input="changeFilter"></date-picker>
            </b-form-group>
          </b-col>
          <b-col lg="3" md="3" sm="6" xl="3">
            <b-form-group label-for="dateAtEnd">
              <template slot="label">{{
                $t(
                  "public.views.Pages.Professional.Admin.Invoices.dateAtEnd"
                )
              }}:
              </template>
              <date-picker v-model="filter.startFrom" :format="myFormat" :formatter="momentFormat" class="w-100"
                type="date" @input="changeFilter"></date-picker>
            </b-form-group>
          </b-col>
          <b-col lg="3" md="3" sm="6" xl="3">
            <b-form-group label-for="professionals">
              <template slot="label">{{
                $t(
                  "public.views.Pages.Professional.Admin.Invoices.professional"
                )
              }}:
              </template>

              <multiselect v-model="filter.professionals" :clear-on-select="false" :close-on-select="false"
                :multiple="true" :options="professionalsFilterSelect" :preselect-first="true" :preserve-search="true"
                label="text" track-by="value" v-bind:deselectGroupLabel="
                  $t(
                    'public.views.Pages.Professional.Admin.Invoices.multiselect.deselectGroupLabel'
                  )
                " v-bind:deselectLabel="
  $t(
    'public.views.Pages.Professional.Admin.Invoices.multiselect.deselectLabel'
  )
" v-bind:placeholder="
  $t(
    'public.views.Pages.Professional.Admin.Invoices.multiselect.placeholder2'
  )
" v-bind:selectGroupLabel="
  $t(
    'public.views.Pages.Professional.Admin.Invoices.multiselect.selectGroupLabel'
  )
" v-bind:selectLabel="
  $t(
    'public.views.Pages.Professional.Admin.Invoices.multiselect.selectLabel'
  )
" v-bind:selectedLabel="
  $t(
    'public.views.Pages.Professional.Admin.Invoices.multiselect.selectedLabel'
  )
" @input="changeFilter">
                <template slot="option" slot-scope="props">
                  <b-list-group-item class="d-flex align-items-center">
                    <b-avatar class="mr-3" v-bind:src="props.option.avatar"></b-avatar>
                    <span class="mr-auto title-typography-color">{{
                      props.option.text
                    }}</span>
                  </b-list-group-item>
                </template>
                <template slot="selection" slot-scope="{ values, isOpen }"><span v-if="values.length && !isOpen"
                    class="multiselect__single">{{ values.length }}
                    {{
                      $t(
                        "public.views.Pages.Professional.Admin.Invoices.selectedProfessionals"
                      )
                    }}</span></template>
              </multiselect>
            </b-form-group>
          </b-col>
          <b-col lg="3" md="3" sm="6" xl="3">
            <b-form-group label-for="patients">
              <template slot="label">{{
                $t("public.views.Pages.Professional.Admin.Invoices.patient")
              }}:
              </template>
              <multiselect v-model="filter.patients" :clear-on-select="false" :close-on-select="false"
                :loading="isLoadingPatients" :multiple="true" :options="patientsFilterSelect" :preselect-first="true"
                :preserve-search="true" label="text" track-by="value" v-bind:deselectGroupLabel="
                  $t(
                    'public.views.Pages.Professional.Admin.Invoices.multiselect.deselectGroupLabel'
                  )
                " v-bind:deselectLabel="
  $t(
    'public.views.Pages.Professional.Admin.Invoices.multiselect.deselectLabel'
  )
" v-bind:placeholder="
  $t(
    'public.views.Pages.Professional.Admin.Invoices.multiselect.placeholder'
  )
" v-bind:selectGroupLabel="
  $t(
    'public.views.Pages.Professional.Admin.Invoices.multiselect.selectGroupLabel'
  )
" v-bind:selectLabel="
  $t(
    'public.views.Pages.Professional.Admin.Invoices.multiselect.selectLabel'
  )
" v-bind:selectedLabel="
  $t(
    'public.views.Pages.Professional.Admin.Invoices.multiselect.selectedLabel'
  )
" @input="changeFilter" @search-change="getAllPatients">
                <template slot="noResult">
                  {{ $t("generic.noResults") }}
                </template>
                <template slot="noOptions">
                  {{ $t("generic.min3") }}
                </template>
                <template slot="option" slot-scope="props">
                  <b-list-group-item class="d-flex align-items-center">
                    <b-avatar class="mr-3" v-bind:src="props.option.avatar"></b-avatar>
                    <span class="mr-auto title-typography-color">{{
                      props.option.text
                    }}</span>
                  </b-list-group-item>
                </template>
                <template slot="selection" slot-scope="{ values, isOpen }"><span v-if="values.length && !isOpen"
                    class="multiselect__single">{{ values.length }}
                    {{
                      $t(
                        "public.views.Pages.Professional.Admin.Invoices.selectedContacts"
                      )
                    }}</span></template>
              </multiselect>
            </b-form-group>
          </b-col>
        </b-row>
      </template>
    </iq-card>
    <iq-card>
      <template v-slot:headerTitle>
        <h4 class="card-title title-typography-color">
          <i class="fas fa-file-invoice-dollar"></i>
          Facturas antiguas
        </h4>
      </template>
      <template v-slot:headerAction></template>
      <template v-slot:body>
        <div>
          <v-data-table :footer-props="{
            showFirstLastPage: true,
            firstIcon: 'fas fa-arrow-left',
            lastIcon: 'fas fa-arrow-right',
            prevIcon: 'fas fa-minus',
            nextIcon: 'fas fa-plus',
            'items-per-page-options': [10, 25, 50],
          }" :headers="headers" :items="invoices" :options.sync="pagination" :search="search"
            :server-items-length="total" item-key="id">
            <template v-slot:item.patient="{ item }">
              <b-list-group-item v-if="item.patient" class="d-flex align-items-center border-0 p-0">
                <b-avatar v-bind:src="
                  item.patient.avatarUrl
                    ? item.patient.avatarUrl +
                    '/' +
                    getAuthentication()
                    : ''
                "></b-avatar>
                <div class="media-support-info ml-3">
                  <p class="mb-0 font-size-16">{{ item.patient.name }}</p>
                  <p class="mb-0 font-size-12">{{ item.patient.lastname }}</p>
                </div>
              </b-list-group-item>
            </template>
            <template v-slot:item.totalCents="{ item }">
              {{ item.totalCents / 100 }} €
            </template>
            <template v-slot:item.duration="{ item }">
              {{ item.duration }} Minutos
            </template>
            <template v-slot:item.createdOldAt="{ item }">
              <div v-if="item.createdOldAt">
                {{ item.createdOldAt | adjustToTimezone("DD/MM/YYYY HH:mm") }}
              </div>
            </template>
            <template v-slot:item.startedAt="{ item }">
              <div v-if="item.startedAt">
                {{ item.startedAt | adjustToTimezone("DD/MM/YYYY HH:mm") }}
              </div>
            </template>
            <template v-slot:item.professional="{ item }">
              <b-list-group-item v-if="item.professional" class="d-flex align-items-center border-0 p-0">
                <b-avatar v-bind:src="
                  item.professional.avatarUrl
                    ? item.professional.avatarUrl +
                    '/' +
                    getAuthentication()
                    : ''
                "></b-avatar>
                <div class="media-support-info ml-3">
                  <p class="mb-0 font-size-16">{{ item.professional.name }}</p>
                  <p class="mb-0 font-size-12">
                    {{ item.professional.lastname }}
                  </p>
                </div>
              </b-list-group-item>
            </template>
            <template v-slot:item.actions="{ item }">
              <div class="div-table-data">
                <button :id="'btnDownload' + item.id" class="item" v-on:click="downloadInvoice(item.oldId)">
                  <i class="ri-file-download-line"></i>
                </button>
                <b-popover :target="'btnDownload' + item.id" placement="botton" triggers="hover focus">
                  <template #title>{{
                    $t(
                      "public.views.Pages.Professional.Admin.Invoices.btnDownload"
                    )
                  }}
                  </template>
                </b-popover>
                <button :id="'btnUpdate' + item.id" class="item" v-on:click="updateOpen(item)">
                  <i class="ri-file-edit-line"></i>
                </button>
                <b-popover :target="'btnUpdate' + item.id" placement="botton" triggers="hover focus">
                  <template #title>Ver factura</template>
                </b-popover>
              </div>
            </template>
          </v-data-table>
        </div>
      </template>
    </iq-card>
    <b-modal id="modal-update" centered hide-footer size="lg">
      <template #modal-title> Factura {{ invoice.invoiceNumber }}</template>
      <b-container>
        <b-col>
          <b-row>
            <h4 class="title-typography-color">
              <i aria-hidden="true" class="fas fa-file-alt mr-2"></i>Paciente
            </h4>
            <hr class="title-typography-color dot-typography" />
          </b-row>
          <b-row>
            <div>
              <h6>
                NOMBRE: {{ invoice.patientName }} {{ invoice.patientLastname }}
              </h6>
              <h6>NIF: {{ invoice.patientDocument }}</h6>
              <h6>DIRECCIÓN: {{ invoice.patientAddress }}</h6>
              <h6>CÓDIGO POSTAL: {{ invoice.patientPostalCode }}</h6>
              <h6>CIUDAD: {{ invoice.patientCity }}</h6>
            </div>
          </b-row>
        </b-col>
        <b-col>
          <b-row>
            <h4 class="title-typography-color">
              <i aria-hidden="true" class="fas fa-file-alt mr-2"></i>Organization
            </h4>
            <hr class="title-typography-color dot-typography" />
          </b-row>
          <b-row>
            <div>
              <h6>NOMBRE: {{ invoice.organizationName }}</h6>
              <h6>NIF: {{ invoice.organizationDocument }}</h6>
              <h6>DIRECCIÓN: {{ invoice.organizationAddress }}</h6>
              <h6>CÓDIGO POSTAL: {{ invoice.organizationPostalCode }}</h6>
              <h6>CIUDAD: {{ invoice.organizationCity }}</h6>
            </div>
          </b-row>
        </b-col>
        <b-col>
          <b-row>
            <h4 class="title-typography-color">
              <i aria-hidden="true" class="fas fa-file-alt mr-2"></i>Otra
              información
            </h4>
            <hr class="title-typography-color dot-typography" />
          </b-row>
          <b-row>
            <div>
              <h6>AÑO: {{ invoice.year }}</h6>
              <h6>
                FECHA: {{ invoice.createdOldAt | adjustToTimezone("DD/MM/YYYY HH:mm") }}
              </h6>
              <h6>TAX: {{ invoice.tax }}</h6>
              <h6>SERVICE: {{ invoice.service }}</h6>
              <h6>TOTAL: {{ invoice.totalCents / 100 }} €</h6>
              <h6>DURACIÓN: {{ invoice.duration }} Minutos</h6>
              <h6>
                ¿ESTA PAGADO?: <span v-if="invoice.isPaid">SI</span><span v-else>NO</span>
              </h6>
            </div>
          </b-row>
        </b-col>
      </b-container>
    </b-modal>
    <notifications group="notificacions" />
  </b-container>
</template>
<script>
import { xray } from "../../../../config/pluginInit";

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/es";

import moment from "moment";

import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";

import validator from "vue-m-validator";

import invoiceService from "../../../../services/invoice";
import professionalService from "../../../../services/professional";
import patientService from "../../../../services/patient";

import utilsService from "../../../../services/utils";

export default {
  name: "InvoiceOld",
  mounted() {
    xray.index();
    this.getAll();
    this.getAllProfessionals();
    utilsService.auditActivity({ action: "VIEW", module: "PROFESSIONAL_INVOICES_OLD", info: "" });
  },
  watch: {
    pagination: {
      handler() {
        if (this.start) {
          this.getAll();
        }
        this.start = true;
      },
    },
  },
  computed: {
    isFormBuyerNameErrors() {
      let errors = this.validator.getErrors("buyer.name");
      return errors && errors.length > 0;
    },
    isFormBuyerLastnameErrors() {
      let errors = this.validator.getErrors("buyer.lastname");
      return errors && errors.length > 0;
    },
    isFormBuyerAddressErrors() {
      let errors = this.validator.getErrors("buyer.address");
      return errors && errors.length > 0;
    },
    isFormBuyerDocumentErrors() {
      let errors = this.validator.getErrors("buyer.document");
      return errors && errors.length > 0;
    },
    isFormSellerNameErrors() {
      let errors = this.validator.getErrors("seller.name");
      return errors && errors.length > 0;
    },
    isFormSellerLastnameErrors() {
      let errors = this.validator.getErrors("seller.lastname");
      return errors && errors.length > 0;
    },
    isFormSellerAddressErrors() {
      let errors = this.validator.getErrors("seller.address");
      return errors && errors.length > 0;
    },
    isFormSellerDocumentErrors() {
      let errors = this.validator.getErrors("seller.document");
      return errors && errors.length > 0;
    },
    isFormItemDescriptionErrors() {
      let errors = this.validator.getErrors("item.name");
      return errors && errors.length > 0;
    },
  },
  methods: {
    getAuthentication() {
      return localStorage.getItem('authorization');
    },
    async getAllPatients() {
      let self = this;

      if (query.length > 2) {
        this.isLoadingPatients = true;

        patientService
          .getAll()
          .then((response) => {
            let combo = [];
            response.data.forEach(function (item) {
              let data = {
                avatar: item.avatarUrl
                  ? item.avatarUrl + "/" + localStorage.getItem("authorization")
                  : "",
                uuid: item.uuid,
                value: item.id,
                text:
                  item.name + " " + item.lastname + " (" + item.document + ") ",
              };
              combo.push(data);
            });
            self.patientsFilterSelect = combo;
            self.isLoadingPatients = false;
          })
          .catch((error) => {
            utilsService.auditErrorFrontent({
              info: "patientService.getAll",
              module: "view-pages-professional-admin-invoicesOld",
              httpStatus: error.response ? error.response.status : null,
              endpoint: window.location.href,
              request: null
            });
            self.isLoadingPatients = false;
          });
      }
    },
    async getAllProfessionals() {
      let self = this;

      professionalService
        .getAll()
        .then((response) => {
          let combo = [];
          response.data.forEach(function (item) {
            let data = {
              avatar: item.avatarUrl
                ? item.avatarUrl + "/" + localStorage.getItem("authorization")
                : "",
              uuid: item.uuid,
              value: item.id,
              text:
                item.name + " " + item.lastname + " (" + item.document + ") ",
            };
            combo.push(data);
          });
          self.professionalsFilterSelect = combo;
        })
        .catch((error) => {
          utilsService.auditErrorFrontent({
            info: "professionalService.getAll",
            module: "view-pages-professional-admin-invoicesOld",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: null
          });
        });
    },
    //Invoice
    downloadInvoice(invoiceId) {
      let self = this;

      this.$awn.asyncBlock(
        invoiceService.generatePdfInvoiceOldEvent(invoiceId),
        (response) => {
          if (response) {
            var byteCharacters = atob(response.data.data);
            var byteNumbers = new Array(byteCharacters.length);
            for (var i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            var byteArray = new Uint8Array(byteNumbers);
            var file = new Blob([byteArray], {
              type: "application/pdf;base64",
            });
            var fileURL = URL.createObjectURL(file);

            var fileLink = document.createElement("a");

            fileLink.href = fileURL;
            fileLink.setAttribute("download", "factura.pdf");
            document.body.appendChild(fileLink);

            fileLink.click();
            this.$notify({
              group: "notificacions",
              title: this.$i18n.t(
                "public.views.Pages.Professional.Admin.Invoices.notification.title"
              ),
              text: this.$i18n.t(
                "public.views.Pages.Professional.Admin.Invoices.notification.descGeneratedInvoice"
              ),
              type: "success",
            });
            this.$bvModal.hide("modal-cita");
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "invoiceService.generatePdfInvoiceOldEvent",
            module: "view-pages-professional-admin-invoicesOld",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              invoiceId: invoiceId
            })
          });
        },
        " "
      );
    },
    goToInvoice() {
      this.$router.push({
        name: "auth.professional.admin.invoices",
      });
    },
    update() {
    },
    updateOpen(item) {
      this.invoice = item;
      this.$bvModal.show("modal-update");
    },
    changeFilter() {
      this.pageSize = 10;
      this.currentPage = 1;
      this.getAll();
    },
    cloneFilterSend() {
      let clone = JSON.parse(JSON.stringify(this.filter));

      //Professionals

      if (clone.professionals) {
        let professionalREST = [];
        clone.professionals.forEach(function (professional) {
          professionalREST.push(professional.value);
        });
        clone.professionals = professionalREST;
      } else {
        clone.professionals = [];
      }

      //Patients

      if (clone.patients) {
        let patientsREST = [];
        clone.patients.forEach(function (patient) {
          patientsREST.push(patient.value);
        });
        clone.patients = patientsREST;
      } else {
        clone.patients = [];
      }

      // StartAt
      if (clone.startTo) {
        clone.startTo = moment(clone.startTo)
          .set("hour", 0)
          .set("minute", 0)
          .set("second", 0)
          .set("millisecond", 0);
      } else {
        clone.startTo = null;
      }

      if (clone.startFrom) {
        clone.startFrom = moment(clone.startFrom)
          .set("hour", 24)
          .set("minute", 0)
          .set("second", 0)
          .set("millisecond", 0);
      } else {
        clone.startFrom = null;
      }

      return clone;
    },
    async getAll() {
      let self = this;

      let data = this.cloneFilterSend();

      this.$awn.asyncBlock(
        invoiceService.getAllOld(
          this.pagination.page - 1,
          this.pagination.itemsPerPage,
          data
        ),
        (response) => {
          if (response) {
            self.invoices = response.data.content;
            self.total = response.data.pageable.total;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "invoiceService.getAllOld",
            module: "view-pages-professional-admin-invoicesOld",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              page: this.pagination.page - 1,
              itemsPerPage: this.pagination.itemsPerPage,
              data: data
            })
          });
        },
        " "
      );
    },
  },
  data() {
    return {
      isLoadingPatients: false,
      start: false,
      total: 0,
      pagination: {},
      pageSize: 10,
      currentPage: 1,

      filter: {
        professionals: [],
        patients: [],
        startTo: null,
        startFrom: null,
      },

      invoices: [],
      professionalsFilterSelect: [],
      patientsFilterSelect: [],

      myFormat: "DD/MM/YYYY",
      momentFormat: {
        //[optional] Date to String
        stringify: (date) => {
          return date ? moment(date).format("LL") : "";
        },
        //[optional]  String to Date
        parse: (value) => {
          return value ? moment(value, "LL").toDate() : null;
        },
        //[optional] getWeekNumber
        getWeek: (date) => {
          // a number
        },
      },

      search: "",

      invoice: {},

      headers: [
        {
          text: "Año",
          value: "year",
        },
        {
          text: "Nº factura",
          align: "start",
          value: "invoiceNumber",
        },
        {
          text: "Professional",
          value: "professional",
        },
        {
          text: "Paciente",
          value: "patient",
        },
        {
          text: "Total",
          value: "totalCents",
        },
        {
          text: "Servicio",
          value: "service",
        },
        {
          text: "Duración",
          value: "duration",
        },
        {
          text: "Comenzó",
          value: "startedAt",
        },
        {
          text: "Creada",
          value: "createdOldAt",
        },
        {
          text: "",
          value: "actions",
        },
      ],

      //Validate
      validator: validator,
      //Data validate form
      isFirstRun: true,
      isValidate: false,
    };
  },

  components: {
    DatePicker,
    Multiselect,
  },
};
</script>
